import {Component} from '@angular/core';
import {HandleImageErrorDirective} from "../../directives/handle-image-error.directive";
import {RouterLink} from "@angular/router";
import {SetImageDimensionsDirective} from "../../directives/set-image-dimensions.directive";
import {CommonConstants} from "@coreConstant";

@Component({
  selector: 'app-flooring-walling-banner-section',
  standalone: true,
  imports: [
    HandleImageErrorDirective,
    RouterLink,
    SetImageDimensionsDirective
  ],
  templateUrl: './flooring-walling-banner-section.component.html',
  styleUrl: './flooring-walling-banner-section.component.scss'
})
export class FlooringWallingBannerSectionComponent {
  protected s3BucketUrl = CommonConstants.IMAGE_KIT_ENDPOINT;

}
